// navigation menu effects //
function navActive(elem){
  var mainlink = $(this).find(".mainlink");
  $(".mainlink").removeClass("white");
  if($(".mainmenu .sub-menu").is(":visible")){
    $(".mainmenu .sub-menu").css("display", "none");
    elem.find(".sub-menu").show();
  }
  else {
    elem.find(".sub-menu").css("display", "block");
  }
  elem.find(".sub-menu").css("opacity", "1");
  elem.closest(".transparent-header").addClass("active submenu-active");
}

function menuTimeout() {
  menuTimer = setTimeout( function() {
    $(".mainmenu .sub-menu").css("display", "none");
    $('#shopify-section-header').removeClass('basket-active');
  }, 300);
}

function navDeactive(){
  $(".mainmenu .sub-menu").css("opacity", "0");
  $(".transparent-header").removeClass("active submenu-active");
  menuTimeout();
}

$(".inside-transparent").on('mouseenter',function(){
  $(this).closest(".transparent-header").addClass("active");
});

$(".main-item").on('mouseenter',function(){
  clearTimeout(menuTimer);
  var elem = $(this);
  if($('.search-window').is(':visible')){
  }
  else {
    navActive(elem);
  }
  if (elem[0].classList.contains('basket-desktop')) {
    $('#shopify-section-header').addClass('basket-active');
  } else {
    $('#shopify-section-header').removeClass('basket-active');
  }
});

$(".transparent-header").on('mouseleave',function(){
  if($('.search-window').is(':visible')){
  }
  else {
    navDeactive();
  }
});

var menuTimer;